export const API_URL = process.env.REACT_APP_API_URL
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY
// export const PRODUCT_ONE_TRACK = process.env.REACT_APP_PRODUCT_ONE_TRACK
// export const PRODUCT_THREE_TRACKS = process.env.REACT_APP_PRODUCT_THREE_TRACKS
export const APPLE_DEVELOPER_TOKEN = process.env.REACT_APP_APPLE_DEVELOPER_TOKEN